import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import ActivityTypeRep1 from "../components/activityTypeRep1";

const ActivityTypeRep = () => {
  const company = JSON.parse(localStorage.getItem("company"));

  return (
    <div className="body">
      <Header />
      <h2>Tipo de Actividad</h2>
      <ActivityTypeRep1 id_c={company?.id_c} />
    </div>
  );
};

export default ActivityTypeRep;
